import { ZoomOutMap } from '@mui/icons-material';
import { ButtonBase, styled } from '@mui/material';
import { useMap } from '@vis.gl/react-google-maps';
import { useSetAtom } from 'jotai';
import { useCallback, useState } from 'react';
import { teamDetailPanelVisible } from '@/common/atoms/community';
import { setImmediate } from '@/common/utils/setImmediate';

// SW and NE coordinates for a bounding box around the contiguous U.S.
export const US_SOUTHWEST = {
  lat: 25.82,
  lng: -124.39,
};

export const US_NORTHEAST = {
  lat: 49.38,
  lng: -66.94,
};

// This is styled to match the default Google zoom controls
const Button = styled(ButtonBase)(({ theme }) => ({
  userSelect: 'none',
  borderRadius: '2px',
  color: '#666',
  backgroundColor: theme.palette.common.white,
  boxShadow: 'rgba(0, 0, 0, 0.3) 0px 1px 4px -1px',
  width: 40,
  height: 40,
  marginRight: '10px',
  '&:hover': {
    color: '#333',
  },
  '&:disabled': {
    color: theme.palette.text.disabled,
  },
}));

export function ShowAllPartnersButton() {
  const map = useMap();
  const [disabled, setDisabled] = useState(false);
  const setTeamDetailPanelVisible = useSetAtom(teamDetailPanelVisible);

  const handleClick = useCallback(() => {
    if (!map) return;

    setDisabled(true);

    map.fitBounds(new google.maps.LatLngBounds(US_SOUTHWEST, US_NORTHEAST), 0);

    // Re-enable button if user changes map bounds with zoom/pan
    setImmediate(() => {
      const listener = map.addListener('bounds_changed', () => {
        listener.remove();
        setDisabled(false);
      });
    });

    // Close team detail panel if open
    setTeamDetailPanelVisible(false);
  }, [map, setTeamDetailPanelVisible]);

  return (
    <Button
      aria-label="Show all partners"
      title="Show all partners"
      disabled={disabled}
      onClick={handleClick}
    >
      <ZoomOutMap fontSize="large" sx={{ color: 'inherit' }} />
    </Button>
  );
}
